import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Icon } from '@material-ui/core';

const styles = {
  filterWrapper: {
    padding: '10px',
    flex: 'auto',
    borderBottom: '1px solid #CCCCCC',
  },
  iconButton: {
    float: 'right',
    padding: '0px',
  },
};

class FilterWrapper extends Component {
  render() {
    const {
      title, children, isAdvancedFilter, isReportsAdvanced, resetFilter, isResetDisabled, style,
    } = this.props;

    if (isAdvancedFilter && !isReportsAdvanced) {
      return null;
    }

    return (
      <div style={style || styles.filterWrapper}>
        <h3>{title}</h3>
        {resetFilter && (
        <IconButton style={styles.iconButton} size="small" onClick={resetFilter} disabled={isResetDisabled}>
          <Icon>clear</Icon>
        </IconButton>
        )}
        {children}
      </div>
    );
  }
}

FilterWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  isAdvancedFilter: PropTypes.bool,
  isReportsAdvanced: PropTypes.bool,
  isResetDisabled: PropTypes.bool,
  style: PropTypes.object,
  resetFilter: PropTypes.func,
};

FilterWrapper.defaultProps = {
  title: '',
  children: [],
  isAdvancedFilter: false,
  isReportsAdvanced: false,
  isResetDisabled: false,
  style: null,
  resetFilter: null,
};

export default FilterWrapper;
